import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ZtTextInputConfig } from './zt-textinput.model';

@UntilDestroy()
@Component({
    selector: 'zt-textinput',
    templateUrl: 'zt-textinput.component.html',
    styleUrls: ['zt-textinput.component.html'],
})
export class ZtTextInputComponent implements OnInit {
    @Input() value: string = '';
    @Input() placeholder: string = '';
    @Input() config: ZtTextInputConfig | undefined;
    @Input() control!: FormControl;
    @Input() disabled: boolean = false;
    @Input() hideChars: boolean = false;
    @Input() hasHideIcon: boolean = false;
    @Input() hasCopyIcon: boolean = false;

    @Output() onChange = new EventEmitter<string>();

    errors: string[] = [];

    constructor() {}

    ngOnInit() {
        if (this.control) {
            this.control.valueChanges
                .pipe(untilDestroyed(this))
                .subscribe((_: any) => {
                    if (
                        this.control.errors &&
                        Object.keys(this.control.errors).length > 0
                    ) {
                        this.errors = Object.keys(this.control.errors).map(
                            (errorType: string) => {
                                let message = '';
                                switch (errorType) {
                                    case 'email':
                                        message =
                                            'Email-ul nu are formatul bun.';
                                        break;
                                    case 'required':
                                        message =
                                            'Acest câmp este obligatoriu.';
                                        break;
                                    case 'minlength':
                                        const minLength =
                                            this.control.getError(
                                                errorType
                                            ).requiredLength;
                                        message =
                                            'Acest câmp trebuie să conțină minim ' +
                                            minLength +
                                            ' caractere.';
                                        break;
                                    default:
                                        break;
                                }
                                return message;
                            }
                        );
                        this.errors = [...new Set(this.errors)];
                    }
                });
        }
    }

    onChangeListener(newValue: string) {
        this.onChange.emit(newValue);
    }

    showCharsListener(): void {
        this.hideChars = false;
    }

    hideCharsListener(): void {
        this.hideChars = true;
    }

    copyToClipboard(): void {
        let textToCopy = '';

        if (this.control) {
            textToCopy = this.control.value;
        } else {
            textToCopy = this.value;
        }

        navigator.clipboard.writeText(textToCopy);
    }
}
